// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1FSRr","obliqueLineWrap":"membershipbadge_obliqueLineWrap__34rrn","obliqueLine":"membershipbadge_obliqueLine__2arL7"};